// extracted by mini-css-extract-plugin
module.exports = {"privacy-card":"Privacy_privacy-card__7-w9v","no-shadow":"Privacy_no-shadow__rys1T","item":"Privacy_item__1kfjp","title":"Privacy_title__kigt2","content":"Privacy_content__3id1O"};